/* eslint-disable */
import * as Types from './schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const ReviewsDocument = gql`
    query Reviews($page: Int, $search: String, $order: Order, $sortField: ReviewSortField, $perPage: Int) {
  user {
    reviews(
      search: $search
      sortField: $sortField
      order: $order
      page: $page
      perPage: $perPage
    ) {
      items {
        uuid
        restaurant {
          id
          name
          slug
          link
          fullAddress
          address
          logo
          types {
            id
            name
          }
          cuisines {
            id
            name
          }
        }
        overallRating
        foodRating
        serviceRating
        atmosphereRating
        billPerPerson
        comment
        createdAt(format: "Y-m-d H:i:s")
        updatedAt(format: "Y-m-d H:i:s")
        photos {
          id
          url
        }
        author
      }
      currentPage
      itemsPerPage
      pageCount
      totalCount
    }
  }
}
    `;

/**
 * __useReviewsQuery__
 *
 * To run a query within a React component, call `useReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      order: // value for 'order'
 *      sortField: // value for 'sortField'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useReviewsQuery(baseOptions?: Apollo.QueryHookOptions<ReviewsQuery, ReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewsQuery, ReviewsQueryVariables>(ReviewsDocument, options);
      }
export function useReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewsQuery, ReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewsQuery, ReviewsQueryVariables>(ReviewsDocument, options);
        }
export function useReviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReviewsQuery, ReviewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewsQuery, ReviewsQueryVariables>(ReviewsDocument, options);
        }
export type ReviewsQueryHookResult = ReturnType<typeof useReviewsQuery>;
export type ReviewsLazyQueryHookResult = ReturnType<typeof useReviewsLazyQuery>;
export type ReviewsSuspenseQueryHookResult = ReturnType<typeof useReviewsSuspenseQuery>;
export type ReviewsQueryResult = Apollo.QueryResult<ReviewsQuery, ReviewsQueryVariables>;
export const DeleteReviewDocument = gql`
    mutation DeleteReview($uuid: Uuid!) {
  deleteReview(uuid: $uuid)
}
    `;
export type DeleteReviewMutationFn = Apollo.MutationFunction<DeleteReviewMutation, DeleteReviewMutationVariables>;

/**
 * __useDeleteReviewMutation__
 *
 * To run a mutation, you first call `useDeleteReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReviewMutation, { data, loading, error }] = useDeleteReviewMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteReviewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReviewMutation, DeleteReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReviewMutation, DeleteReviewMutationVariables>(DeleteReviewDocument, options);
      }
export type DeleteReviewMutationHookResult = ReturnType<typeof useDeleteReviewMutation>;
export type DeleteReviewMutationResult = Apollo.MutationResult<DeleteReviewMutation>;
export type DeleteReviewMutationOptions = Apollo.BaseMutationOptions<DeleteReviewMutation, DeleteReviewMutationVariables>;
export const UpdateReviewDocument = gql`
    mutation UpdateReview($uuid: Uuid!, $overallRating: Int!, $atmosphereRating: Int, $foodRating: Int, $serviceRating: Int, $comment: String, $billPerPerson: ReviewBillPerPerson, $photos: [Upload!]) {
  updateReview(
    uuid: $uuid
    input: {overallRating: $overallRating, atmosphereRating: $atmosphereRating, foodRating: $foodRating, serviceRating: $serviceRating, comment: $comment, billPerPerson: $billPerPerson, photos: $photos}
  ) {
    uuid
  }
}
    `;
export type UpdateReviewMutationFn = Apollo.MutationFunction<UpdateReviewMutation, UpdateReviewMutationVariables>;

/**
 * __useUpdateReviewMutation__
 *
 * To run a mutation, you first call `useUpdateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReviewMutation, { data, loading, error }] = useUpdateReviewMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      overallRating: // value for 'overallRating'
 *      atmosphereRating: // value for 'atmosphereRating'
 *      foodRating: // value for 'foodRating'
 *      serviceRating: // value for 'serviceRating'
 *      comment: // value for 'comment'
 *      billPerPerson: // value for 'billPerPerson'
 *      photos: // value for 'photos'
 *   },
 * });
 */
export function useUpdateReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReviewMutation, UpdateReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReviewMutation, UpdateReviewMutationVariables>(UpdateReviewDocument, options);
      }
export type UpdateReviewMutationHookResult = ReturnType<typeof useUpdateReviewMutation>;
export type UpdateReviewMutationResult = Apollo.MutationResult<UpdateReviewMutation>;
export type UpdateReviewMutationOptions = Apollo.BaseMutationOptions<UpdateReviewMutation, UpdateReviewMutationVariables>;
export const DeleteReviewPhotoDocument = gql`
    mutation DeleteReviewPhoto($reviewUuid: Uuid!, $photoId: Int!) {
  deleteReviewPhoto(reviewUuid: $reviewUuid, photoId: $photoId)
}
    `;
export type DeleteReviewPhotoMutationFn = Apollo.MutationFunction<DeleteReviewPhotoMutation, DeleteReviewPhotoMutationVariables>;

/**
 * __useDeleteReviewPhotoMutation__
 *
 * To run a mutation, you first call `useDeleteReviewPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReviewPhotoMutation, { data, loading, error }] = useDeleteReviewPhotoMutation({
 *   variables: {
 *      reviewUuid: // value for 'reviewUuid'
 *      photoId: // value for 'photoId'
 *   },
 * });
 */
export function useDeleteReviewPhotoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReviewPhotoMutation, DeleteReviewPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReviewPhotoMutation, DeleteReviewPhotoMutationVariables>(DeleteReviewPhotoDocument, options);
      }
export type DeleteReviewPhotoMutationHookResult = ReturnType<typeof useDeleteReviewPhotoMutation>;
export type DeleteReviewPhotoMutationResult = Apollo.MutationResult<DeleteReviewPhotoMutation>;
export type DeleteReviewPhotoMutationOptions = Apollo.BaseMutationOptions<DeleteReviewPhotoMutation, DeleteReviewPhotoMutationVariables>;
export type ReviewsQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  order?: Types.InputMaybe<Types.Order>;
  sortField?: Types.InputMaybe<Types.ReviewSortField>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ReviewsQuery = { __typename?: 'Query', user: { __typename?: 'UserProxyType', reviews: { __typename?: 'ReviewPaginatedType', currentPage?: number | null, itemsPerPage?: number | null, pageCount?: number | null, totalCount?: number | null, items?: Array<{ __typename?: 'ReviewType', uuid: any, overallRating: number, foodRating?: number | null, serviceRating?: number | null, atmosphereRating?: number | null, billPerPerson?: Types.ReviewBillPerPerson | null, comment?: string | null, createdAt: string, updatedAt: string, author?: string | null, restaurant?: { __typename?: 'RestaurantType', id: number, name: string, slug: string, link: string, fullAddress: string, address: string, logo: string, types: Array<{ __typename?: 'RestaurantTypeType', id: number, name: string }>, cuisines: Array<{ __typename?: 'RestaurantCuisineType', id: number, name: string }> } | null, photos: Array<{ __typename?: 'PhotoType', id: number, url: string }> }> | null } } };

export type DeleteReviewMutationVariables = Types.Exact<{
  uuid: Types.Scalars['Uuid']['input'];
}>;


export type DeleteReviewMutation = { __typename?: 'Mutation', deleteReview: boolean };

export type UpdateReviewMutationVariables = Types.Exact<{
  uuid: Types.Scalars['Uuid']['input'];
  overallRating: Types.Scalars['Int']['input'];
  atmosphereRating?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  foodRating?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  serviceRating?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  comment?: Types.InputMaybe<Types.Scalars['String']['input']>;
  billPerPerson?: Types.InputMaybe<Types.ReviewBillPerPerson>;
  photos?: Types.InputMaybe<Array<Types.Scalars['Upload']['input']> | Types.Scalars['Upload']['input']>;
}>;


export type UpdateReviewMutation = { __typename?: 'Mutation', updateReview: { __typename?: 'ReviewType', uuid: any } };

export type DeleteReviewPhotoMutationVariables = Types.Exact<{
  reviewUuid: Types.Scalars['Uuid']['input'];
  photoId: Types.Scalars['Int']['input'];
}>;


export type DeleteReviewPhotoMutation = { __typename?: 'Mutation', deleteReviewPhoto: boolean };
